export default "__VITE_PUBLIC_ASSET__7f758e2b__"